export type BenefitCategory = 'rights' | 'discount' | 'activity' | 'service';

export interface ExclusiveBenefit {
  id: string;
  name: string;
  icon: string;
  category: BenefitCategory;
  enabled?: boolean;
  /** 权益详细说明（可选） */
  description?: string;
}

const CATEGORY_LABELS: Record<BenefitCategory, string> = {
  rights: '权利',
  discount: '优惠',
  activity: '活动',
  service: '服务',
};

export { CATEGORY_LABELS };

const listeners = new Set<() => void>();

const _benefits: ExclusiveBenefit[] = [];

function notify() {
  listeners.forEach((fn) => fn());
}

export const benefitsStore = {
  getAll(): ExclusiveBenefit[] {
    return [..._benefits];
  },

  getById(id: string): ExclusiveBenefit | undefined {
    return _benefits.find((b) => b.id === id);
  },

  getByIds(ids: string[]): ExclusiveBenefit[] {
    return ids.map((id) => _benefits.find((b) => b.id === id)).filter(Boolean) as ExclusiveBenefit[];
  },

  add(item: Omit<ExclusiveBenefit, 'id'>) {
    _benefits.push({ ...item, id: `b${Date.now()}`, enabled: item.enabled !== false });
    notify();
  },

  update(id: string, changes: Partial<Omit<ExclusiveBenefit, 'id'>>) {
    const idx = _benefits.findIndex((b) => b.id === id);
    if (idx !== -1) Object.assign(_benefits[idx], changes);
    notify();
  },

  toggleEnabled(id: string) {
    const benefit = _benefits.find((b) => b.id === id);
    if (benefit) {
      benefit.enabled = !(benefit.enabled !== false);
      notify();
    }
  },

  remove(id: string) {
    const idx = _benefits.findIndex((b) => b.id === id);
    if (idx !== -1) _benefits.splice(idx, 1);
    notify();
  },

  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  /** 与 GET /exclusive-benefits 同步 */
  replaceFromApi(items: ExclusiveBenefit[]): void {
    _benefits.length = 0;
    for (const b of items) {
      _benefits.push({ ...b, enabled: b.enabled !== false });
    }
    notify();
  },
};

// Default level benefit mapping (levelId -> benefitIds)
export const DEFAULT_LEVEL_BENEFITS: Record<string, string[]> = {
  l1: ['b9', 'b10', 'b11', 'b13', 'b20'],
  l2: ['b14', 'b15', 'b16', 'b17', 'b18'],
};
